export const IdApplication = import.meta.env.VITE_ID_APP;
export const REDIRECT_URL_LOGIN = import.meta.env.VITE_REDIRECT_URL_LOGIN;
export const DEFAULT_LENGUAJE = "es";
export const DOMAINNAME = import.meta.env.VITE_DOMAINNAME;
export const API_URL = import.meta.env.VITE_API_URL;
export const IP_API_URL = import.meta.env.VITE_API_URL;
export const DEFAULT_CSS = ""//"http://192.168.0.3:444/CSS/MLTi/CSS/MLTi.css?ver=0";
export const htmlCtrlattrCode = "action-code"
export const htmlCssToValidatePermission = "CtrlPermission"
export const LocalStorageParameterName = "Parameters"
export const CompanyTokenKey = "ic"
export const UserTokenKey = import.meta.env.VITE_SESSION_TOKEN;
export const CONFIG_CSS_INTERNALLOGIN = "CONFIG_CSS_InternalLogin"
export const MaxItemsAutocomplete = 100 
export const HTTPS = "https"
export const HTTP = "http"
export const PIGNUS = "PIGNUS"
export const LANG_COOKIE = "langCookie"
export const AUTH_PROXY_URL =  import.meta.env.VITE_AUTH_PROXY_URL;
export const AUTH_VALIDATE = import.meta.env.VITE_AUTH_VALIDATE;


export const AUTHENTICATED_STATES = {
  CHECKING : "CHECKING",
  AUTHENTICATED :"AUTHENTICATED",
  NOTAUTHENTICATED:"NOT_AUTHENTICATED"
}
//logotipo
export const LOGO2 = "2_"
export const BLANK = ""
export const EMAIL_HELP = "";

//Ruta en servidor
export const ServeRoute = "/APP/LOGIN"//`http://${ window.location.href.includes(DOMAINNAME) ? DOMAINNAME : IP }/APP/MEETINGSCHEDULE`//"/APP/Meetingschedulev2" //"/APP/CRM" //Local Cambiar Por "/"

export const STATUS_CODE_SERVER = {
  NOT_FOUND : 404,
  BAD_REQUEST : 400,
  OK:200
}
